import React from 'react'
import list from '../assets/list.svg'

export default function Header({ showSidebar }) {
  return (
    <header className="">
      
      <div>
        <button onClick={() => showSidebar()}>
          <i className="bi bi-music-note-list header-icon"></i>
        </button>
      </div>
    </header>
  );
}
